import React, { useEffect, useRef } from 'react'
import { InputAdornment, IconButton } from '@mui/material'
import { useSearchWithDebounce } from '@/hooks'
import { InputField } from './input'

interface SearchInputProps {
  placeholder?: string
  onSearch: (value: string) => void
  initialValue?: string
  debounceDelay?: number
  className?: string
  size?: 'small' | 'medium'
  fullWidth?: boolean
}

export const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Search...',
  onSearch,
  initialValue = '',
  debounceDelay = 500,
  className = '',
  fullWidth = false
}) => {
  const { searchValue, debouncedSearchValue, handleSearchChange, clearSearch } = useSearchWithDebounce(
    initialValue,
    debounceDelay
  )

  const latestOnSearch = useRef(onSearch)

  useEffect(() => {
    latestOnSearch.current = onSearch
  }, [onSearch])

  // Gọi onSearch khi debouncedSearchValue thay đổi
  useEffect(() => {
    latestOnSearch.current(debouncedSearchValue)
  }, [debouncedSearchValue])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSearchChange(event.target.value)
  }

  const handleClear = () => {
    clearSearch()
  }

  return (
    <InputField
      value={searchValue}
      onChange={handleInputChange}
      placeholder={placeholder}
      fullWidth={fullWidth}
      className={className}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position='start'>
              <i className='tabler-search text-gray-400' />
            </InputAdornment>
          ),
          endAdornment: searchValue && (
            <InputAdornment position='end'>
              <IconButton size='small' onClick={handleClear} edge='end'>
                <i className='tabler-x text-gray-400' />
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  )
}
